import { isEnumValue } from '@cas/utils/typeHelpers';
import {
  AssetGIModel,
  AssetInteractionModelBase,
  AssetVIModel,
  GIType,
  VIType,
} from '@customer/store/apis/interactionsApi';
import {
  AssetInvestigationType,
  CustomInvestigationModel,
  InvestigationModel,
  LoggedInvestigationModel,
} from '@customer/store/apis/investigationsApi';

export interface InvestigationTypeReturn {
  vi?: VIType;
  gi?: GIType;
  custom?: boolean;
}

export const isLoggedInvestigation = (inv: InvestigationModel): inv is LoggedInvestigationModel => {
  return inv.it !== AssetInvestigationType.Unknown && inv.it !== AssetInvestigationType.Custom;
};

export const isCustomInvestigation = (inv: InvestigationModel): inv is CustomInvestigationModel => {
  return inv.it === AssetInvestigationType.Custom;
};

export const isAssetGIModel = (
  interaction: AssetInteractionModelBase | InvestigationModel,
): interaction is AssetGIModel => {
  return isEnumValue(interaction.it, GIType);
};

export const isAssetVIModel = (
  interaction: AssetInteractionModelBase | InvestigationModel,
): interaction is AssetVIModel => {
  return isEnumValue(interaction.it, VIType);
};

export const parseInvestigationType = (it?: AssetInvestigationType): InvestigationTypeReturn => {
  if (typeof it !== 'undefined' && it !== AssetInvestigationType.Unknown) {
    if (it === AssetInvestigationType.Custom) {
      return { custom: true };
    } else if (isEnumValue(it, VIType)) {
      return { vi: it };
    } else if (isEnumValue(it, GIType)) {
      return { gi: it };
    }
  }

  return {};
};

export const viToInvestigationType = (viType?: VIType): AssetInvestigationType => {
  return typeof viType !== 'undefined'
    ? AssetInvestigationType[viType]
    : AssetInvestigationType.Unknown;
};

export const giToInvestigationType = (giType?: GIType): AssetInvestigationType => {
  return typeof giType !== 'undefined'
    ? AssetInvestigationType[giType]
    : AssetInvestigationType.Unknown;
};
